<div class="flex flex-column items-end jumbotron mb-6 p-6">
    @if (closable) {
        <div>
            <button mat-icon-button (click)="onClose()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    }
    <div class="flex justify-content-arround gap-[48px] px-6 pb-6">
        @if (imageSrc) {
            <div class="flex justify-center items-center">
                <img class="image" [src]="imageSrc" />
            </div>
        }
        <div class="flex flex-column gap-4">
            @if (title) {
                <h3 class="ca-headline-3 mb-0">{{ title }}</h3>
            }
            <div class="content"><ng-content></ng-content></div>
        </div>
    </div>
</div>
